const PdfIcon = () => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 16 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.45508 16.1818V2C1.45508 0.895431 2.35051 0 3.45508 0H9.6304C10.1473 0 10.6442 0.200143 11.0167 0.558458L13.9323 3.36241C14.3244 3.73948 14.546 4.25998 14.546 4.80395V16.1818C14.546 17.2864 13.6506 18.1818 12.546 18.1818H3.45508C2.35051 18.1818 1.45508 17.2864 1.45508 16.1818Z"
        fill="#006299"
      />
      <rect
        x="0.808696"
        y="7.39707"
        width="14.3826"
        height="6.53947"
        rx="1.34783"
        fill="white"
        stroke="#006299"
        strokeWidth="1.61739"
      />
      <path
        d="M2.73102 12.7371C2.69337 12.7371 2.65949 12.7239 2.62937 12.6976C2.60302 12.6675 2.58984 12.6336 2.58984 12.5959V8.92536C2.58984 8.88394 2.60302 8.85006 2.62937 8.82371C2.65949 8.79736 2.69337 8.78418 2.73102 8.78418H4.3122C4.79408 8.78418 5.17243 8.89524 5.44726 9.11736C5.72584 9.33947 5.86514 9.66324 5.86514 10.0887C5.86514 10.5103 5.72773 10.8284 5.4529 11.043C5.17808 11.2538 4.79784 11.3592 4.3122 11.3592H3.6402V12.5959C3.6402 12.6374 3.62514 12.6712 3.59502 12.6976C3.56867 12.7239 3.53479 12.7371 3.49337 12.7371H2.73102ZM4.28396 10.5799C4.44961 10.5799 4.57949 10.5385 4.67361 10.4557C4.76773 10.3691 4.81479 10.243 4.81479 10.0774C4.81479 9.923 4.76961 9.80065 4.67926 9.7103C4.59267 9.61618 4.4609 9.56912 4.28396 9.56912H3.62326V10.5799H4.28396Z"
        fill="#006299"
      />
      <path
        d="M6.5472 12.7371C6.50955 12.7371 6.47567 12.7239 6.44555 12.6976C6.4192 12.6675 6.40602 12.6336 6.40602 12.5959V8.92536C6.40602 8.88394 6.4192 8.85006 6.44555 8.82371C6.47567 8.79736 6.50955 8.78418 6.5472 8.78418H8.01543C8.56884 8.78418 8.99802 8.91594 9.30296 9.17947C9.6079 9.443 9.7679 9.82512 9.78296 10.3258C9.78673 10.435 9.78861 10.5799 9.78861 10.7607C9.78861 10.9414 9.78673 11.0844 9.78296 11.1898C9.76414 11.7131 9.6079 12.1028 9.31426 12.3588C9.02437 12.611 8.60084 12.7371 8.04367 12.7371H6.5472ZM8.01543 11.9239C8.2639 11.9239 8.44649 11.8656 8.5632 11.7489C8.6799 11.6284 8.74202 11.4383 8.74955 11.1785C8.75708 11.0694 8.76084 10.9282 8.76084 10.755C8.76084 10.5818 8.75708 10.4425 8.74955 10.3371C8.74202 10.0849 8.67426 9.89853 8.54626 9.77806C8.42202 9.65759 8.23567 9.59736 7.9872 9.59736H7.42249V11.9239H8.01543Z"
        fill="#006299"
      />
      <path
        d="M10.5895 12.7371C10.5518 12.7371 10.5179 12.7239 10.4878 12.6976C10.4615 12.6675 10.4483 12.6336 10.4483 12.5959V8.92536C10.4483 8.88394 10.4615 8.85006 10.4878 8.82371C10.5179 8.79736 10.5518 8.78418 10.5895 8.78418H13.1871C13.2285 8.78418 13.2624 8.79736 13.2888 8.82371C13.3151 8.85006 13.3283 8.88394 13.3283 8.92536V9.49571C13.3283 9.53336 13.3151 9.56724 13.2888 9.59736C13.2624 9.62371 13.2285 9.63689 13.1871 9.63689H11.4422V10.467H13.0742C13.1156 10.467 13.1495 10.4821 13.1758 10.5122C13.2022 10.5385 13.2154 10.5724 13.2154 10.6138V11.1785C13.2154 11.2162 13.2022 11.2501 13.1758 11.2802C13.1495 11.3065 13.1156 11.3197 13.0742 11.3197H11.4422V12.5959C11.4422 12.6374 11.429 12.6712 11.4027 12.6976C11.3763 12.7239 11.3424 12.7371 11.301 12.7371H10.5895Z"
        fill="#006299"
      />
      <path
        d="M9.88281 4.16662V2.01812C9.88281 1.54774 10.4431 1.30295 10.7882 1.62253L13.1086 3.77103C13.4684 4.10419 13.2327 4.70575 12.7423 4.70575H10.4219C10.1242 4.70575 9.88281 4.46437 9.88281 4.16662Z"
        fill="white"
      />
    </svg>
  );
};

export default PdfIcon;
